import React from 'react';

import { getStep } from './api';

import Nav from './Nav';
import Step from './Step';

import Stepper, { StepperConsumer } from './Stepper';
import Form, { FormConsumer } from './Form';
import ErrorMessage from './ErrorMessage';

class App extends React.PureComponent {
  addToCart(data, setError, setLoading) {
    setLoading(true);
    setError('generic');

    getStep(data)
      .then(
        (res) => {
          if (res && res.redirect_url) {
            window.location = res.redirect_url;
          } else {
            setLoading(false);
          }
        },
        (error) => {
          setLoading(false);

          setError('generic', error);
        }
      );
  }

  calculateTotals(values) {
    const totalLength = values.total_length || 0;
    const extras = values.extras ? Object.keys(values.extras).reduce((a, b) => a + values.extras[b], 0) : 0;
    const total = ((values.variation_price || 0) * (totalLength / 1000)) + extras;

    return total;
  }

  formatPrice(total) {
    return window.MTMReact.currency_format
      .replace('%f', total.toFixed(2).replace('.', ','))
      .replace('%s', window.MTMReact.currency_symbol);
  }

  haveErrors(errors) {
    const keys = Object.keys(errors);

    return keys.length !== 0 && !(keys.length === 1 && keys[0] === 'generic');
  }

  render() {
    return (
      <React.StrictMode>
        <Form defaultValues={{
          rail_type: window.MTMReact.railType,
          quantity: 1,
          extras: {
            base: parseInt(window.MTMReact.basePrice, 10) || 0,
          }
        }}>
          <FormConsumer>
            {({ values, errors, setError, setLoading }) => {
              const haveErrors = this.haveErrors(errors)
              const typeLabel = `${window.MTMReact.railTypes[values.rail_type].label}${values.meter_price ? ':' : ''}`;

              return (
                <Stepper haveErrors={haveErrors}>
                  <ErrorMessage />

                  <div id="mtm-main" className="row">
                    <Nav />

                    <Step />
                  </div>

                  <footer id="mtm-footer">
                    <input type="hidden" name="rail_type" value={values.rail_type} />

                    <div id="mtm-selected-product">
                      <div id="mtm-type">{typeLabel} <span className="price">{values.meter_price}</span></div>
                    </div>

                    <div id="mtm-forward">
                      <div id="mtm-price">
                        Totalpris: <span className="price">{this.formatPrice(this.calculateTotals(values))}</span>
                      </div>

                      <StepperConsumer>
                        {({ steps, step, setStep }) => {
                          const nextStep = Object.keys(steps)[step + 1];
                          return (
                            <button
                              id="mtm-next-button"
                              className={`cta ${haveErrors ? 'disabled' : ''}`}
                              onClick={(e) => {
                                e.preventDefault();

                                if (haveErrors) {
                                  setError('generic', 'Obligatoriska fält saknas');

                                  window.scrollTo(0, 0);
                                } else {
                                  setError('generic');

                                  if (nextStep) {
                                    setStep(step + 1);
                                  } else {
                                    this.addToCart({ ...values, step: step + 1 }, setError, setLoading);
                                  }
                                }
                              }}>
                              {nextStep ? steps[nextStep].label : 'Lägg till varukorg'} <i className="icon-arrow-right"></i>
                            </button>
                          );
                        }}
                      </StepperConsumer>
                    </div>
                  </footer>
                </Stepper>
              );
            }}
          </FormConsumer>
        </Form>
      </React.StrictMode>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js